import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { InputCost } from '../inputmodels/inputcost.model';
import { InputItem } from '../../inputcommon/inputcommon.class';

const API = '/api/construction-projects/v1/cockpit-inputcosts/';

@Injectable({ providedIn: 'root' })
export class InputCostService {

  inputcost: InputCost = new InputCost();
  inputCosts: InputCost[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoInput(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.inputCosts = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.inputCosts.length > 0) {
        this.inputcost = this.inputCosts[0];
      }
    }
    return this.inputcost;
  }

  async GetInfoInputByTask(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/bytask/' + itm.taskid;
      this.inputCosts = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.inputCosts.length > 0) {
        this.inputcost = this.inputCosts[0];
      }
    }
    return this.inputcost;
  }

}

